import { inject, Pipe, PipeTransform } from '@angular/core';
import { UserService } from '../services/user.service';

@Pipe({
  name: 'userReplace',
  standalone: true
})
export class UserReplacePipe implements PipeTransform {
  private userService = inject(UserService);

  transform(value: string): string {
    if (!value) return value;

    const currentUser = this.userService.userProfile();
    const displayName = currentUser?.displayName || 'Unknown User';

    return value.replace(/{{User}}/g, displayName);
  }
}
